import httpService from "@/shared/http";
import config from "@/shared/config";
import Vue from 'vue'
const vm = Vue.prototype
// @ts-ignore
import { pathOr } from 'ramda';
import { checkNotNeededService } from "@/shared/utils";

export const actions={
  async getUserInfo(store:any) {
    try {
    /* guidance: check not needed this service in current route */
    if(checkNotNeededService('getUserInfo')) return;

      const url = config.api_url + config.resources.user_info;
      const response = await httpService.get(url);
      const data = pathOr(null, ['data', 'data'], response)
      store.commit('updateUserInfo', data);
    } catch (error) {
      vm.$generateError(error);
    }
  }
}
